import Vue from 'vue'
import Scroll from 'vue-perfect-scrollbar'

import ThSort from '@/components/partial/ThSort'

Vue.component('ThSort', ThSort)
Vue.component('Scroll', Scroll)
